import Vue from 'vue'
// import Vuex from 'vuex'

// Vue.use(Vuex);

const state = {/* */}
const mutations = {/* */}

export default {};
// export default new Vuex.Store({
//     state,
//     mutations
// })